var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBottomLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 835,
    height: 487,
    viewBox: "0 0 835 487",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2921_12054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.795 291.998C253.757 297.946 261.821 298.585 261.881 304.712C258.208 314.493 247.669 315.291 239.725 317.527C207.509 326.609 175.872 337.368 144.115 347.827C77.6274 369.723 10.9999 391.2 -55.2283 413.835C-88.6618 425.273 -122.634 434.953 -156.008 446.53",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.863 293.994C230.865 297.826 236.873 298.145 235.975 302.237C231.384 312.996 220.086 311.639 211.823 313.515C181.982 320.281 152.561 328.605 123.239 337.088C68.5078 352.936 13.8565 369.144 -40.2359 387.009C-85.426 401.939 -130.776 416.61 -174.948 434.534C-177.183 435.432 -179.579 435.891 -181.914 436.55",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.024 299.962C182.819 307.647 176.831 308.804 172.02 309.842C135.733 317.667 100.103 327.966 64.3945 337.986C26.5498 348.605 -10.8159 360.901 -48.3812 372.538C-93.5913 386.53 -138.203 402.179 -182.894 417.688C-194.012 421.54 -204.85 426.251 -215.828 430.582",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.668 282.018C299.747 286.549 299.488 290.94 302.582 295.052C310.406 305.491 309.927 307.826 297.632 313.814C287.592 318.685 277.013 322.437 266.793 326.908C232.86 341.799 198.928 356.689 165.095 371.779C119.845 391.939 74.755 412.458 29.4651 432.518C-1.97239 446.43 -33.6494 459.824 -65.2266 473.457",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.727 290.002C276.727 291 276.348 292.217 276.787 292.956C283.414 304.353 282.236 308.764 269.721 313.854C242.894 324.733 215.888 335.112 189.001 345.851C135.987 367.028 83.3317 389.144 30.2972 410.223C-15.6115 428.486 -61.0012 448.307 -108.108 463.516C-109.205 463.876 -110.124 464.814 -111.102 465.473",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.604 284.014C321.285 292.736 330.067 297.108 331.484 305.211C329.089 312.158 322.981 315.132 316.634 317.926C277.053 335.411 238.469 354.952 199.886 374.573C154.057 397.887 107.49 419.764 61.4215 442.598C31.042 457.668 0.822077 473.018 -30.3359 486.411",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.537 288.006C343.639 291.599 346.792 292.876 348.529 294.992C355.555 303.555 355.575 308.804 347.611 317.008C341.782 323.016 334.577 326.908 327.511 330.761C286.792 352.977 245.414 374.035 205.074 396.949C174.395 414.374 143.317 431.021 112.119 447.389C78.3066 465.134 44.7933 483.557 9.52344 498.427",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.469 288.006C367.67 290.9 369.886 292.217 371.443 294.014C380.066 304.014 379.866 310.142 369.387 317.827C357.431 326.589 345.055 334.833 332.54 342.817C289.087 370.542 245.673 398.326 201.9 425.532C163.177 449.604 124.614 473.996 84.3341 495.453C80.5217 497.489 77.0086 500.064 73.3359 502.399",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.407 288.006C389.407 292.158 393.499 293.235 395.415 295.97C401.523 304.693 403.04 312.637 394.457 319.982C375.315 336.37 356.532 353.176 337.55 369.763C306.671 396.71 276.072 423.995 244.715 450.403C223.717 468.068 201.62 484.435 180.023 501.381",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.336 288.006C412.777 292.856 417.787 294.233 419.684 297.786C427.428 312.238 423.995 322.916 410.043 337.567C376.011 373.296 342.298 409.364 306.828 443.716C286.05 463.836 265.59 484.255 243.893 503.417C242.516 504.635 241.857 506.691 240.859 508.347",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.828 262.077C265.794 261.059 279.966 268.624 293.539 277.287C295.894 278.784 298.429 281.02 300.665 280.82C315.056 279.523 328.609 284.253 342.562 285.99C351.484 287.088 360.646 286.908 369.468 286.648C416.774 285.271 463.96 286.329 511.066 290.94C528.651 292.656 546.336 293.175 563.881 295.112C589.85 297.986 615.738 301.639 641.667 304.972C645.619 305.471 648.373 308.944 652.625 309.004C671.807 309.283 690.669 312.238 709.472 315.89C732.705 320.381 755.999 324.573 779.253 328.884",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.25 288.006C437.25 289.343 436.791 291.599 437.31 291.858C446.232 296.13 451.062 303.495 450.983 312.936C450.883 324.453 448.587 335.591 442.34 345.911C426.092 372.737 406.531 397.149 388.387 422.618C367.788 451.54 345.333 478.846 318.586 502.379",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.183 290.002C464.042 291.898 459.191 292.397 462.145 295.032C481.387 312.058 480.09 332.836 473.203 354.833C464.281 383.276 449.411 408.586 432.165 432.498C416.955 453.596 400.947 474.115 383.422 493.397",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.499 198.264C685.697 205.071 674.579 205.031 664.559 208.125C612.622 224.193 562.382 244.133 514.997 270.999C509.587 274.073 503.719 276.369 498.07 279.024",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.116 294.992C501.781 302.477 506.252 318.645 507.749 334.892C511.621 376.909 500.883 416.151 482.16 453.536C476.85 464.135 471.621 474.714 462.18 482.439",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.996 115.509C822.485 118.164 777.834 118.363 733.382 122.335C718.512 123.653 703.222 121.557 688.611 123.992C676.535 126.008 664.539 125.229 652.603 126.008C632.622 127.305 612.762 129.96 592.862 131.657C567.452 133.812 541.464 135.429 517.092 144.591C513 146.128 510.645 144.97 508.07 142.455",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.256 231.179C747.491 235.31 720.265 242.137 693.598 250.44C657.829 261.598 622.28 273.734 588.787 290.94C587.988 291.339 586.811 291 585.812 291",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55291 332.876C3.39322 329.623 1.85628 327.228 -0.379274 324.852C-44.5514 278.066 -95.6498 241.478 -155.89 217.985C-161.878 215.65 -167.427 212.217 -173.914 211.219",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.69 197.266C607.41 204.911 586.752 211.677 566.951 220.38C528.128 237.466 490.343 256.708 454.195 279.024",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-74.2333 191.298C-77.8661 208.344 -70.2213 216.408 -54.5325 223.714C-8.20471 245.291 34.4305 273.075 71.337 308.944",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.19 245.131C777.258 251.438 753.206 257.347 729.433 264.173C697.816 273.255 666.478 283.355 635.68 294.972",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.039 298.964C529.604 306.289 539.724 320.601 547.968 336.829C559.624 359.743 564.255 384.114 563.896 409.644C563.696 423.935 564.455 438.247 562.878 452.518",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.062 193.274C489.467 200.54 475.375 204.312 462.162 210.201C423.499 227.446 386.013 246.927 350.584 270.161C348.607 271.459 346.572 272.157 344.516 273.036",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.875 199.262C525.615 216.708 486.093 235.73 447.191 256.029C434.137 262.856 422.24 271.778 408.328 277.028",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.324 221.199C720.705 229.642 690.246 238.584 660.545 250.001C638.688 258.405 616.572 266.129 595.773 277.028",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.138 252.117C760.225 262.856 708.348 280.122 657.609 300.98",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-119.086 214.212C-82.6584 230.759 -48.2269 250.64 -16.2904 274.912C-1.95895 285.81 12.113 296.908 25.4864 308.924C27.9615 311.16 29.758 314.313 33.4506 314.912",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.795 168.364C210.924 168.025 166.053 167.665 121.202 167.446C117.909 167.446 114.376 166.268 111.242 168.364",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.86 208.244V189.302C199.626 189.302 166.372 188.563 133.158 189.542C108.208 190.28 83.2976 190.14 58.3672 190.3",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.706 284.014C283.8 290.261 274.857 289.123 266.754 289.802C237.113 292.317 207.531 295.032 178.01 298.844C119.347 306.449 61.7015 318.964 4.55521 333.894C-41.3535 345.891 -86.4837 360.561 -130.975 376.929C-169.279 391.001 -206.984 406.71 -243.711 424.594",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.215 193.274C409.548 214.592 364.977 239.742 321.683 267.167C319.986 268.245 318.689 269.363 316.633 269.063",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.608 220.201C618.288 233.454 579.984 251.458 542 270.141C534.395 273.874 527.329 278.704 520.023 283.016",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.213 236.149C742.939 245.949 700.644 259.063 658.607 273.075C655.513 274.113 652.619 275.69 649.625 277.028",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.203 156.387C165.076 157.385 208.949 158.084 252.801 159.581C264.438 159.98 276.075 160.16 287.712 160.38C290.826 160.439 294.139 159.741 296.694 162.376",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.856 199.262C189.979 200.26 148.102 201.298 106.226 202.156C102.912 202.216 98.9802 203.893 96.2656 200.26",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.883 191.298C539.604 200.6 519.224 209.662 499.104 219.282C476.03 230.3 453.216 241.818 430.281 253.115",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.945 300.96C553.259 307.647 563.079 318.206 571.842 329.882C586.213 349.104 600.305 368.466 611.902 389.604C617.711 400.203 621.284 411.52 625.695 422.598",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4688 225.191C68.9063 243.674 107.05 267.626 143.079 295.052C145.195 296.668 148.009 298.365 147.111 301.978",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.875 304.952C592.4 314.633 615.255 331.28 635.734 351.759C650.684 366.689 662.441 383.715 671.563 402.678",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.258 177.326C140.484 177.326 177.71 177.286 214.936 177.406C218.249 177.406 221.762 176.228 224.916 178.324",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.478 122.495C338.486 121.038 314.513 123.233 290.74 125.07C274.792 126.307 258.465 123.952 242.876 128.603C234.492 131.098 228.764 127.325 222.876 122.535C217.386 118.084 211.498 114.571 203.953 117.525",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.384 215.21C690.126 224.352 650.046 237.087 611.742 255.091",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.292 195.27C389.725 215.869 353.178 236.488 316.611 257.087C313.637 258.764 310.623 260.421 307.648 262.077",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.189 273.055C772.662 274.852 747.133 282.157 721.504 288.345C708.649 291.439 695.535 294.792 683.539 300.98",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.609 188.304C660.947 189.302 662.364 191.278 663.581 191.158C683.861 189.042 702.524 196.468 721.347 201.558C760.249 212.037 798.114 225.61 833.104 246.109C833.603 246.408 834.422 246.149 835.08 246.149",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.182 283.016C770.83 283.495 738.115 292.477 705.5 302.038C702.167 303.016 699.173 305.072 695.5 304.952",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.482 132.455C352.502 132.455 342.542 132.256 332.582 132.495C310.645 133.034 288.709 133.573 266.793 134.611C262.082 134.83 257.471 137.106 252.82 138.443",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.789 306.948C639.386 319.004 675.514 339.024 699.487 376.749",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21.3733 214.212C-21.4331 215.949 -24.8863 217.366 -20.4551 219.362C16.4515 235.969 50.863 256.848 83.3185 281",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.203 134.451C129.644 130.838 138.766 135.629 148.108 135.809C161.76 136.068 175.613 137.705 188.926 140.739C201.182 143.533 213.577 144.451 225.893 146.328C229.146 146.827 232.879 147.326 235.793 146.228C246.053 142.415 254.895 147.026 263.698 150.539C271.043 153.473 278.648 153.214 285.654 152.076C305.954 148.763 326.253 151.278 346.533 150.419C351.842 150.2 357.172 150.38 362.481 150.38",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-327.469 205.25C-312.299 204.312 -296.83 206.049 -283.337 195.61C-279.325 192.496 -272.159 192.017 -266.67 192.596C-259.284 193.394 -252.438 193.614 -245.691 190.3C-238.386 186.707 -232.238 191.737 -226.969 194.651C-217.927 199.642 -208.685 200.68 -198.845 201.358C-172.238 203.214 -145.67 201.179 -119.083 201.119C-109.243 201.119 -99.7617 197.286 -91.3584 192.895C-81.9571 187.985 -72.1766 189.582 -63.2743 189.981C-52.0567 190.5 -40.5196 190.24 -29.3618 192.336C-18.3636 194.392 -8.94239 200.819 1.57669 204.192C18.3633 209.562 35.0701 213.115 49.4215 198.264",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.159 223.195C447.951 234.692 423.08 248.744 398.409 263.115C389.647 268.225 381.104 273.714 372.461 279.043",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.155 195.27C441.584 208.444 408.489 224.672 376.453 243.135",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.483 140.439C334.519 138.962 306.694 143.393 278.73 142.675C273.5 142.535 267.711 143.573 262.781 146.427",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.413 207.246C361.403 220.72 335.554 232.656 311.642 248.145C305.215 252.297 298.987 256.768 292.68 261.079",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.148 226.189C135.907 231.618 135.807 237.107 142.075 240.241C168.582 253.434 194.331 267.946 217.904 286.01",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.608 197.266C642.526 200.799 624.761 208.404 606.817 215.31C594.322 220.121 582.186 225.849 569.891 231.159",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.992 229.183C494.754 243.414 464.434 259.303 436.25 279.043",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.978 235.151C202.036 230.7 212.276 224.372 223.873 221.179C229.98 219.502 235.05 216.748 234.092 209.223C203.553 208.823 172.335 210.54 141.117 212.217",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.908 236.149C533.718 247.726 510.165 262.337 486.153 276.089C485.215 276.628 484.796 278.026 484.117 279.024",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.586 311.938C669.512 318.744 679.293 319.004 687.556 322.816C704.363 330.561 721.03 338.325 733.425 352.777C734.323 353.815 736.02 354.154 737.357 354.813",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.583 99.5605C322.82 106.547 312.701 108.463 301.683 108.702C288.05 109.002 274.377 110.12 260.804 111.617C241.083 113.792 235.774 123.493 243.838 141.437C244.137 142.116 244.496 142.775 244.836 143.433",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64.25 257.087C-37.104 274.692 -12.8523 295.63 8.52521 319.902",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.092 58.6819C325.052 59.3805 326.889 60.7977 324.593 60.638C300.581 58.9015 277.487 62.9335 254.712 70.3786C250.92 71.6162 246.708 72.1551 242.836 73.6322",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.195 144.431C141.138 145.768 160.08 147.266 179.042 148.303C183.673 148.563 188.743 149.9 192.994 146.427",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.208 161.378C123.493 150.419 121.497 136.168 112.296 128.383C105.27 122.435 98.2037 116.826 93.8324 107.744C89.9201 99.6004 79.3811 98.6623 71.2772 95.7281C65.7482 93.7321 63.3929 99.5605 60.4588 102.634C49.4207 114.191 37.0852 124.451 27.1649 137.206C24.4503 140.699 18.1629 141.417 13.4922 143.413",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.094 203.254C473.399 213.694 450.345 223.354 428.289 235.151",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32.3516 255.091C-6.70258 265.95 14.2557 283.215 33.4575 302.956",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.977 68.1631C537.729 69.9396 541.342 67.8637 544.915 67.4046C547.41 67.0853 549.426 66.4066 551.961 67.6043C572.221 77.2052 593.179 79.8399 614.696 72.5145C619.646 70.8178 624.616 69.6203 629.686 68.6422C633.978 67.8039 639.367 71.0374 642.521 66.5863C646.712 60.6381 652.062 54.3506 653 47.644C653.878 41.3964 649.746 34.3903 647.61 27.8034C645.036 19.8592 639.686 17.1048 631.682 19.7994C631.383 19.8992 630.864 19.9591 630.704 19.7994C622.68 10.8572 613.419 18.1626 604.756 17.8233",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.313 241.139C395.035 253.095 373.778 265.071 352.5 277.028",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2812 247.127C111.796 258.345 133.034 271.498 152.096 288.006",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.855 24.7895C571.505 25.3683 564.02 19.5199 561.685 29.6797C552.264 25.7275 546.914 26.5659 542.962 32.7736C538.611 39.6199 542.663 47.5442 540.367 54.8297C539.908 56.2868 544.619 59.3606 546.954 61.676",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3672 255.091C87.1439 266.409 105.827 282.177 125.188 296.968",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.78 206.248C260.465 210.58 259.566 214.492 253 216.767C236.792 222.376 221.562 230.839 205.953 238.145",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.594 61.6758C330.566 66.067 329.508 71.4763 329.568 76.6261C329.887 101.357 331.624 98.6423 350.506 105.569C352.582 106.327 354.498 107.525 356.494 108.523",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.52 170.859C342.881 177.665 329.647 180.32 318.689 179.442C298.01 177.765 277.331 180.32 256.772 177.526C251.642 176.827 246.053 176.208 240.844 178.344",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.944 190.3C520.864 196.887 502.301 206.667 484.117 217.226",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.74 205.25C272.219 211.697 270.522 216.109 263.875 219.442C250.183 226.308 237.169 234.492 223.875 242.137",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.859 75.6282C574.414 94.3709 581.221 112.375 581.84 131.457",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.954 221.199C205.609 217.985 203.114 218.304 200.958 218.185C192.235 217.745 183.373 217.845 175.089 220.38C165.888 223.215 155.828 221.698 147.185 226.308C144.989 227.486 142.754 227.606 141.177 227.027C125.668 221.338 108.182 219.023 98.2422 203.234",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.148 253.115C135.448 257.467 139.18 258.325 142.115 260.121C157.604 269.642 172.614 279.862 187.005 291",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.969 246.129C199.027 253.694 206.552 252.975 211.043 255.929C223.358 264.033 236.193 271.379 248.828 279.023",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.64 184.312C309.644 184.132 308.945 186.428 306.65 186.428C282.378 186.548 258.126 186.947 233.874 187.326C231.878 187.346 233.315 185.929 232.876 185.31",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.791 78.6223C602.679 95.9678 596.172 112.595 593.797 129.481",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.42188 239.143C9.56235 246.828 25.2112 258.425 41.439 269.064",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.214 298.964C770.448 295.89 754.38 299.742 738.352 303.954",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.802 264.073C576.175 269.123 560.347 276.029 544.938 284.014",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.605 182.316C318.944 185.31 319.104 188.324 319.643 191.278C321.1 199.362 318.625 205.051 310.661 208.284C297.128 213.773 286.07 224.033 271.838 228.444C268.704 229.402 265.511 232.356 263.634 236.089C262.237 238.863 259.163 240.979 255.83 240.041C248.924 238.105 244.033 241.857 238.844 245.131",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.656 170.36C292.46 166.607 280.065 167.945 267.789 169.541C264.316 170.001 261.122 170.959 257.789 169.362",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.125 230.181C150.72 235.73 155.75 236.648 161.079 237.187C166.409 237.726 171.818 238.065 177.008 239.243C192.337 242.676 209.543 243.235 222.377 250.959C237.707 260.181 254.194 270.221 263.715 287.028C263.995 287.527 263.755 288.345 263.755 289.004",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.746 191.298C595.714 195.969 582.281 202.097 568.867 208.244",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2734 107.545C107.369 107.545 127.19 121.317 131.162 132.475",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.795 71.6362C254.194 84.6104 252.538 97.6844 255.791 110.519",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.031 249.123C188.584 255.011 201.678 261.738 213.914 270.061",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.094 262.077C169.507 269.502 182.681 277.307 192.98 289.004",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.361 118.503C389.726 110.818 377.111 116.207 364.477 118.503",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.609 226.189C307.433 232.436 296.974 242.057 282.742 244.233C278.151 244.931 275.756 248.644 274.758 253.095",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.783 23.7912C605.294 19.7991 604.037 16.0266 600.863 11.7751C597.151 6.82491 592.041 5.6872 586.891 7.06446C582.679 8.18224 578.268 9.83891 579.446 16.8849C580.105 20.8171 576.831 25.6874 579.925 29.7194C584.675 35.8871 582.739 41.1566 578.907 46.7655C573.378 54.8095 572.1 64.2507 570.883 73.652",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.207 103.553C118.788 106.886 120.145 108.643 123.06 110.718C129.786 115.469 135.375 121.876 142.301 126.228C146.373 128.783 146.014 131.577 146.114 134.97",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.443 207.246C698.968 207.626 687.551 212.715 675.555 215.23",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.519 201.258C352.718 206.348 349.904 209.242 345.553 211.258C336.032 215.65 326.411 218.344 315.852 220.38C303.137 222.815 289.205 227.107 277.748 235.191C273.795 237.985 269.404 238.544 264.773 238.165",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.307 259.083C411.764 266.608 400.786 269.962 391.325 275.93C389.948 276.808 388.59 277.207 388.391 279.024",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2734 102.555C101.401 98.8421 107.409 96.1674 114.335 101.397C116.192 102.794 119.525 102.515 122.2 102.495C128.487 102.475 132.839 103.193 136.711 110.219C140.444 116.966 148.647 121.337 155.154 126.407C158.288 128.842 161.841 130.639 161.082 135.449",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.733 35.7476C615.234 42.9333 615.713 49.7797 620.663 55.7278C623.697 59.3806 625.194 63.8716 625.713 68.6421",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.093 109.541C152.214 116.367 159.081 116.886 161.935 120.619C166.546 126.667 176.726 127.685 177.025 137.465",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.79 261.079C256.091 259.123 255.592 257.586 252.837 256.948C244.574 254.992 236.869 250.361 227.867 252.117",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.148 105.549C146.568 103.533 155.869 109.501 166.049 109.68C171.179 109.78 168.045 116.307 171.897 118.722C178.045 122.575 182.935 128.483 189.123 132.216C192.975 134.531 192.995 137.106 192.955 140.439",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.483 250.121C350.844 256.768 340.205 263.415 329.586 270.061",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.121 114.511C486.114 112.714 491.443 109.82 493.778 114.671C497.351 122.156 505.495 127.744 504.038 137.445C503.938 138.144 503.579 139.062 503.04 139.401C492.7 146.008 483.818 155.39 470.165 155.469C460.804 155.529 457.211 150.859 457.85 141.397C458.109 137.505 464.317 132.575 457.211 128.962",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.961 222.197C191.001 227.606 178.506 227.386 170.062 236.149",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.008 115.509C187.307 124.551 196.389 125.409 200.98 130.439C204.134 133.892 208.804 136.507 206.948 142.415",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.039 111.517C180.438 109.62 192.295 111.776 199.301 116.467C207.505 121.956 214.551 130.818 222.734 137.625C223.872 138.583 222.894 142.096 222.894 144.411",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.038 171.358C506.15 173.933 515.771 178.144 509.523 180.38C529.903 184.971 549.125 178.523 567.827 182.555C579.963 185.17 590.822 178.224 602.818 180.1C611.56 181.458 620.183 182.875 628.846 184.611C640.563 186.967 653.557 188.823 665.593 183.334",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.672 280.021C629.032 285.012 619.391 290.002 609.75 294.972",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.78 208.244C252.137 208.903 243.494 209.582 234.852 210.24",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4609 139.441C31.2554 143.793 30.4969 148.683 30.3971 153.393C30.2973 157.944 30.7165 162.176 34.449 165.35",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.749 42.7335C603.603 34.8492 595.319 31.1765 584.82 35.7474",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.367 182.316C409.246 193.633 421.401 187.426 433.238 184.711C434.715 184.372 437.21 182.515 437.05 181.857C434.815 172.196 445.274 171.338 448.208 165.37",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3906 229.183C62.8159 234.791 72.6563 236.249 79.323 243.135",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.792 188.304C256.594 191.717 260.047 194.072 259.748 198.284H233.859",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2734 235.151C109.924 241.598 124.415 248.464 140.124 252.197C142.939 252.876 145.474 254.752 148.128 256.089",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.254 213.214C105.671 220.819 100.162 230.62 111.24 235.151",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4688 235.151C33.9319 238.025 41.0577 243.275 48.4031 248.105",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.889 213.214C551.786 214.791 544.021 217.107 537.953 223.195",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.887 212.236C220.181 217.705 210.879 213.973 203.953 218.723",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.591 221.199C328.19 231.738 320.146 234.193 312.641 237.147",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.25 181.318C451.304 189.062 453.021 187.765 463.021 177.186C465.236 174.831 469.787 175.629 470.167 171.358",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.906 273.055C224.495 278.784 231.9 281.539 238.847 285.012",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.477 164.372C368.467 168.024 373.337 171.837 378.447 175.31C389.605 182.855 393.557 182.456 403.357 173.354",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.565 173.334C669.629 176.907 665.498 176.907 662.484 178.024C658.551 179.501 655.897 180.919 655.617 185.29",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.422 203.254C374.255 204.272 368.127 205.211 362.438 208.165C358.985 209.961 355.173 210.66 351.5 208.244",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.53 68.6621C342.682 65.7479 336.654 66.5064 330.586 67.6641",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.779 265.071C261.921 274.014 268.488 277.407 274.735 281.02",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.816 280.021C579.506 282.676 574.177 285.331 568.867 288.006",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.214 154.392C450.801 158.424 446.729 159.042 441.4 160.14C430.941 162.276 418.905 161.717 410.262 170.28C409.084 171.438 407.008 171.677 405.352 172.336",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.418 180.32C384.378 185.39 384.817 190.52 382.422 195.27",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.993 150.419C519.184 157.046 510.701 152.415 504.054 155.429C501.34 156.647 498.725 158.064 496.07 159.402",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2734 291C97.5849 294.652 101.916 298.305 106.228 301.958",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.359 159.382C402.579 163.873 400.503 168.903 405.354 172.336",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.188 173.334C460.98 184.951 464.473 186.408 481.12 183.294C482.457 183.034 483.775 182.635 485.112 182.316",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.789 46.7256C604.596 49.7995 597.629 54.1109 598.787 57.6838",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.666 173.334C636.855 174.392 635.278 177.965 634.68 182.316",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.101 127.485C492.418 132.375 485.951 138.323 493.097 142.435",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.87 171.358C568.373 174.531 566.177 177.505 566.876 181.338",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.117 175.33C483.616 180.14 485.932 184.053 491.041 182.595C496.89 180.939 502.519 186.128 508.048 182.316",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.422 196.268C378.426 199.342 372.418 197.845 372.438 203.254",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.705 236.149C287.509 238.604 282.799 238.544 282.719 243.135",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.789 242.137C256.869 245.271 256.33 248.045 252.797 249.123",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.25 145.429C438.589 147.765 438.909 150.08 439.248 152.415",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.639 177.326C643.299 179.821 642.98 182.316 642.641 184.811",
    stroke: "#193C34",
    strokeOpacity: 0.1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2921_12054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 834,
    height: 502,
    fill: "white",
    transform: "translate(0.929688)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLeft);
export default __webpack_public_path__ + "static/media/bottom-left.eedb938d37732114a40f6d703e6e8767.svg";
export { ForwardRef as ReactComponent };